import {useMemo} from 'react';

import {getJourneyInfo} from '@/services/loyalty/loyaltyUtils';

import {useJourney} from './useJourney';

export const useJourneyInfo = (journeyId?: string) => {
    const journey = useJourney(journeyId);

    return useMemo(() => {
        if (!journey) {
            return null;
        }
        const {currentLevelBadge, ...restInfo} = getJourneyInfo(journey);
        const {badgeId} = currentLevelBadge || {};

        return {
            journey,
            journeyName: journey.journeyName,
            journeyId: journey.journeyId,
            journeyDescription: journey.journeyDescription,
            currentLevelBadge,
            badgeId,
            ...restInfo,
        };
    }, [journey]);
};
